import React, { Component, useEffect, useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { Card, Col, Row, Form, Button, CardBody, CardHeader, Badge, ModalBody, ModalHeader, Modal, CustomInput } from 'reactstrap';
import { getAPI, postAPI } from "../../Base/API";
import { ErrorAlert } from "../../Common/ErrorAlert";
import BlockUi from 'react-block-ui';
import moment from 'moment';
import { CustomDateRangePicker } from '../../Base/Common/CustomReactDates';
import { handleNotification } from '../../Base/Notification';
import { CustomTable } from '../../Base/Common/CustomTable';
import { FormatAmountNumber } from '../../Base/Common/CommonUIComponents';
import { Pagination, ResultsPerPage, TotalResults } from '../../Base/Common/PaginationComponents';


const paymentLinksStatus = [
    { value: 'active', label: 'Active', color: 'primary' },
    { value: 'expired', label: 'Expired', color: 'danger' },
    { value: 'deactivated', label: 'Deactivated', color: 'secondary' },
    { value: 'completed', label: 'Completed', color: 'success' },
    { value: 'scheduled', label: 'Scheduled', color: 'warning' }
];

class Shift4PaymentLinks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            totalCount: 0,
            payouts: [],
            totalCount: 0,
            limit: 10,
            startingAfter: null,
            endingBefore: null,
            page: 0,
        }
    }

    componentDidMount() {
        this.getPaymentLinks()
    }

    getPaymentLinks = (endingBefore, startingAfter) => {
        this.setState({ block: true });

        var params = `?startDate=${moment(this.props.startDate).format("YYYY-MM-DD")}&endDate=${moment(this.props.endDate).format("YYYY-MM-DD")}&limit=${this.state.limit}`;

        if (endingBefore) params += `&endingBefore=${endingBefore}`;
        else if (startingAfter) params += `&startingAfter=${startingAfter}`;
        
        if (this.state.status) params += `&status=${this.state.status}`;


        getAPI(result => {
            const { data, error } = result;
            var errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }

                var payouts = data.response[0]?.list;
                var totalCount = data.response[0]?.totalCount;
                var hasMore = data.response[0]?.hasMore;
                var endingBefore = null;
                var startingAfter = null;

                if (payouts?.length > 0) {
                    var page = this.state.page; 
                    
                    if (page === 0 && totalCount > this.state.limit) startingAfter = payouts[payouts.length - 1]?.id;
                    if (page !== 0) {
                        if (hasMore ) {
                            startingAfter = payouts[payouts.length - 1]?.id;
                        }
                            
                        endingBefore = payouts[0]?.id;
                    }
                }
                

                this.setState({ 
                    payouts, totalCount,
                    hasMore, startingAfter, endingBefore, 
                    block: false, 
                    error: errorMessage 
                });
            }
            else {
                this.setState(({ block: false, error: errorMessage }));
            }
        }, `/api/Price/Shift4/v1/paymentLinks` + params);
    }

    changeLinkStatus = (e, linkId, isToDeactivate) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ block: true });

        postAPI(result => {
            const { data, error } = result;
            var errorMessage = [];
            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }
                if (data.response?.length > 0) {
                    handleNotification({}, <FormattedMessage id={`PaymentManagement.PaymentLink${isToDeactivate ? 'Deactivated' : 'Reactivated'}`} />, <FormattedMessage id="General.Success" />);
                    this.getPaymentLinks();
                }
            }
            else {
                this.setState(({ block: false, error: errorMessage }));
            }
        }, `/api/Price/Shift4/v1/paymentLinks/${linkId}/${isToDeactivate ? 'deactivate' : 'reactivate' }`);
    }

    doSearch = (evt) => {
        evt.preventDefault();

        this.setState({ page: 0 }, () => this.getPaymentLinks());
    }

    handlePagination = (direction) => {
        const { endingBefore, startingAfter, page } = this.state;

        if (direction === -1 && endingBefore) {
            this.setState(
                { page: page - 1 },
                () => this.getPaymentLinks(endingBefore, null)
            );
        } else if (direction === 1 && startingAfter) {
            this.setState(
                { page: page + 1 },
                () => this.getPaymentLinks(null, startingAfter)
            );
        }
    }
        
    changePageSize = (evt) => {
        const { value } = evt.target;

        if (this.state.limit !== value) {
            this.setState({ limit: value, page: 0 }, _ => this.getPaymentLinks());
        }
    }

    toggleModal = (modal, selectedLink) => {
        this.setState(prevState => ({
            [modal]: !prevState[modal],
            selectedLink: selectedLink
        }));
    }


    render() {
        const { block, payouts, totalCount, limit, endingBefore, startingAfter, page, modal, selectedLink } = this.state;

        const columns = [
            {
                dataField: 'title',
                text: this.props.intl.formatMessage({ id: "generic.name" })
            },
            {
                dataField: 'totalAmount',
                text: this.props.intl.formatMessage({ id: "generic.Amount" }),
                formatter: (cell, row) => <FormatAmountNumber value={cell / 100} currency={row.currency} />
            },
            {
                dataField: 'created',
                text: this.props.intl.formatMessage({ id: "generic.Date" }),
                formatter: (cell) => moment.unix(cell).format("MM/DD/YYYY")
            },
            {
                dataField: 'url',
                text: "URL",
                formatter: (cell) => <div>
                    {cell} 
                    <span onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(cell) }}>
                        <i className="far fa-copy ml-3 pointer" />
                    </span>
                </div>
            },
            {
                dataField: 'status',
                text: this.props.intl.formatMessage({ id: "generic.Status" }),
                formatter: (cell) => {
                    const status = paymentLinksStatus.find(status => status.value === cell);

                    if (status) {
                        return <Badge color={status.color} className="py-1 px-2">{status.label}</Badge>
                    }
                }
            },
            {
                dataField: '',
                text: '',
                formatter: (cell, row) => {
                    var isToDeactivate = null;

                    if (row.status === 'deactivated' && (!row.restrictions || row.restrictions?.charges?.limit > row.restrictions?.charges?.count)) {
                        isToDeactivate = false;
                    }
                    else if (row.status === 'active') {
                        isToDeactivate = true;
                    }


                    return isToDeactivate !== null ? <Button className={ "btn-sm float-right " + (isToDeactivate ? "btn btn-danger" : "btn btn-host")} onClick={(e) => this.changeLinkStatus(e, row.id, isToDeactivate)}>
                        {isToDeactivate ? 'Deactivate' : 'Reactivate'}
                    </Button> : '';
                },
                headerStyle: { width: "8%" }
            }
        ]

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,

            onSelect: (row, isSelect, rowIndex, e) => {
                this.toggleModal('modal', row);
            }
        };

        return (
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={this.state.error} />
                
                <Card className="border-0 shadow ">
                    <CardHeader className="bg-white border-bottom py-2">
                        <div><span className="fas fa-link mr-2"> </span> <FormattedMessage id="PaymentManagement.PaymentLinks" /> </div>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={this.doSearch} className="mb-4">
                            <Row className="align-items-end">
                                <Col>
                                    <CustomDateRangePicker
                                        required
                                        startDate={this.props.startDate}
                                        startDateId="your_unique_start_date_id_payouts"
                                        isOutsideRange={day => day > moment()}
                                        endDate={this.props.endDate}
                                        endDateId="your_unique_end_date_id_payouts"
                                        onDatesChange={(startDate, endDate) => this.props.handleDates({ startDate, endDate })}
                                        numberOfMonths={1}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <Button className="btn btn-host btn-sm " type="submit">
                                        <i className="fa fa-search" />
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                        <Row>
                            <Col>
                                <CustomTable
                                    data={payouts || []}
                                    columns={columns}
                                    search={false}
                                    small={true}
                                    exportCSV={false}
                                    hideSizePerPage={true}
                                    sizePerPage={limit}
                                    hasPagination={false}
                                    selectRow={selectRow}
                                />
                            </Col>
                        </Row>
                            {totalCount > 0 ?
                                <div className="py-4 d-flex align-items-center">
                                    <div className='w-50' style={{maxWidth: '50%'}}>
                                        <ResultsPerPage
                                            changeSizePerPage={this.changePageSize}
                                            pageSize={limit}
                                        />
    
                                        {!global.isMobile ?
                                            <span className="ml-2">
                                                <TotalResults
                                                    end={page * limit + payouts.length}
                                                    start={page * limit + 1}
                                                    total={totalCount}
                                                />
                                            </span>
                                        :''}
                                    </div>
                                    <div className="w-50 d-flex justify-content-end" style={{maxWidth: '50%'}}>
                                        <Pagination
                                            isPrevDisabled={!endingBefore}
                                            isNextDisabled={!startingAfter}
                                            currentPage={page + 1}
                                            handlePrevButton={() => this.handlePagination(-1)}
                                            handleNextButton={() => this.handlePagination(1)}
                                        />
                                    </div>
                                </div>
                            : ''}
                    </CardBody>
                </Card>
                
                {(modal && selectedLink) ?
                    <PaymentLinkDetails
                        modal={modal}
                        toggleModal={() => this.toggleModal('modal')}
                        selectedLink={selectedLink}
                        intl={this.props.intl}
                        startDateProps={this.props.startDate}
                        endDateProps={this.props.endDate}
                        chargeStatus={this.props.chargeStatus}
                    />
                : ''}
            </BlockUi>
        )
    }
}

export default injectIntl(Shift4PaymentLinks);

const PaymentLinkDetails = ({ modal, toggleModal, selectedLink, intl, startDateProps, endDateProps, chargeStatus }) => {
    const [startDate, setStartDate] = useState(startDateProps);
    const [endDate, setEndDate] = useState(endDateProps);
    const [block, setBlock] = useState(false);
    const [charges, setCharges] = useState([]);
    const [limit, setLimit] = useState(5);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [startingAfter, setStartingAfter] = useState(null);
    const [endingBefore, setEndingBefore] = useState(null);

    const status = paymentLinksStatus.find(s => s.value === selectedLink.status);
    
    useEffect(() => {
        getCustomerCharges(endingBefore, startingAfter);
    }, [page, limit]);

    const getCustomerCharges = (endingBefore, startingAfter) => {
        setBlock(true);

        var params = `?startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(endDate).format("YYYY-MM-DD")}&limit=${limit}`;

        if (endingBefore) params += `&endingBefore=${endingBefore}`;
        else if (startingAfter) params += `&startingAfter=${startingAfter}`;

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                setBlock(false);
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    setBlock(false);
                    return;
                }

                var charges = data.response[0]?.list;
                var totalCount = data.response[0]?.totalCount;
                var hasMore = data.response[0]?.hasMore;
                var endingBefore = null;
                var startingAfter = null;

                if (charges?.length > 0) {
                    if (page === 0 && totalCount > limit) startingAfter = charges[charges.length - 1]?.id;
                    if (page !== 0) {
                        if (hasMore) {
                            startingAfter = charges[charges.length - 1]?.id;
                        }
                            
                        endingBefore = charges[0]?.id;
                    }
                }

                setCharges(charges);
                setTotalCount(totalCount);
                setStartingAfter(startingAfter);
                setEndingBefore(endingBefore);
                setBlock(false);
            }
            else {
                setBlock(false);
            }
        }, `/api/Price/Shift4/v1/paymentLinks/${selectedLink.id}/charges` + params);
    }

    const doSearch = (evt) => {
        evt.preventDefault();

        setPage(0);
        getCustomerCharges();
    }

    const handlePagination = (direction) => {
        if (direction === -1 && endingBefore) {
            setPage(page - 1);
        } 
        else if (direction === 1 && startingAfter) {
            setPage(page + 1);
        }
    }
        
    const changePageSize = (evt) => {
        const { value } = evt.target;

        if (limit !== value) {
            setStartingAfter(null);
            setEndingBefore(null);
            setLimit(value);
            setPage(0);
        }
    }

    const columns = [
        {
            dataField: 'id',
            text: "Id"
        },
        {
            dataField: 'created',
            text: intl.formatMessage({ id: "generic.Date" }),
            formatter: (cell) => moment.unix(cell).format("MM/DD/YYYY")
        },
        {
            dataField: 'type',
            text: intl.formatMessage({ id: "generic.Type" })
        },
        {
            dataField: 'amount',
            text: intl.formatMessage({ id: "generic.Amount" }),
            formatter: (cell, row) => <FormatAmountNumber value={(row.amount / 100).toFixed(2)} currency={row.currency} />
        }, 
        {
            dataField: 'description',
            text: intl.formatMessage({ id: "generic.Description" })
        },
        {
            dataField: 'customerId',
            text: intl.formatMessage({ id: "PaymentManagement.Customer" })
        },
        {
            dataField: 'captured',
            text: intl.formatMessage({ id: "PaymentManagement.Captured" }),
            formatter: (cell, row) => 
                <CustomInput
                    type="checkbox"
                    className="mb-1"
                    checked={cell}
                    disabled
                    id={`capture_${row.id}`}
                />
        },
        {
            dataField: 'refunded',
            text: intl.formatMessage({ id: "PaymentManagement.Refunded" }),
            formatter: (cell, row) => 
                <CustomInput
                    type="checkbox"
                    className="mb-1"
                    checked={cell}
                    disabled
                    id={`capture_${row.id}`}
                />
        },
        {
            dataField: 'disputed',
            text: intl.formatMessage({ id: "PaymentManagement.Disputed" }),
            formatter: (cell, row) => 
                <CustomInput
                    type="checkbox"
                    className="mb-1"
                    checked={cell}
                    disabled
                    id={`capture_${row.id}`}
                />
        },
        {
            dataField: 'status',
            text: intl.formatMessage({ id: "generic.Status" }),
            formatter: (cell) => {
                const status = chargeStatus.find(status => status.value === cell);

                if (status) {
                    return <Badge color={status.color}>{status.label}</Badge>
                }
            }
        }
    ]
    
    return (
        <Modal isOpen={modal} toggle={toggleModal} fade={false} className="modal-xl" >
            <ModalHeader toggle={toggleModal}  >
                <FormattedMessage id="PaymentManagement.PaymentLinkDetails" />
            </ModalHeader>
            <ModalBody>
                <BlockUi tag="div" blocking={block}>
                    <Card className="border-0">
                        <CardHeader className="mb-1 bg-light-dark py-2">
                            <Row>
                                <Col>
                                    <b><FormattedMessage id="PaymentManagement.PaymentLink" /></b>
                                </Col>
                                <Col className="text-right">
                                    {selectedLink?.url} <i className='far fa-copy ml-3'/>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.Title" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{selectedLink?.title} </b> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="generic.Status" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <Badge color={status?.color}>{status?.label}</Badge> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="generic.Amount" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b><FormatAmountNumber value={selectedLink?.totalAmount / 100} currency={selectedLink?.currency}/> </b> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="generic.CreatedDate" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{moment.unix(selectedLink?.created).format("MM/DD/YYYY")} </b></Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.LastOpened" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{moment.unix(selectedLink?.lastOpened).format("MM/DD/YYYY")} </b></Col>
                                    </Row>
                                        <hr/>
                                    <Row>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.ActivatesAt" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{selectedLink?.restrictions?.dates?.activatesAt  ? moment.unix(selectedLink?.restrictions?.dates?.activatesAt).format("MM/DD/YYYY") : '-'} </b></Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.ExpiresAt" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{selectedLink?.restrictions?.dates?.expiresAt ? moment.unix(selectedLink?.restrictions?.dates?.expiresAt).format("MM/DD/YYYY") : '-'} </b></Col>
                                        <Col sm={6} className="mb-2 py-1">  <FormattedMessage id="PaymentManagement.ChargesLimit" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b><FormattedMessage id="PaymentManagement.ChargesLimitText" values={{ limit: selectedLink?.restrictions?.charges?.limit, count: selectedLink?.restrictions?.charges?.count  }} /> </b> </Col>
                                    </Row>
                                        <hr/>
                                    <Row>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.BillingAddress" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{selectedLink?.collectBillingAddress ?  <FormattedMessage id="generic.yes" /> : <FormattedMessage id="generic.no" />} </b></Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.ShippingAddress" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{selectedLink?.collectShippingAddress ?  <FormattedMessage id="generic.yes" /> : <FormattedMessage id="generic.no" />} </b></Col>
                                        <Col sm={6} className="mb-2 py-1"> <FormattedMessage id="PaymentManagement.Language" /> </Col>
                                        <Col sm={6} className="mb-2 py-1"> <b>{selectedLink?.locale} </b></Col>
                                    </Row>
                                </Col>
                                <Col className="col-8">
                                    {selectedLink?.url ? 
                                        <iframe
                                            src={selectedLink.url}
                                            title="Payment Link Preview"
                                            style={{ width: '100%', height: '600px', border: 'none' }}
                                        />
                                    : ''}
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    
                    <Card className="border-0 mt-3">
                        <CardHeader className="mb-1 bg-light-dark py-2">
                            <b><FormattedMessage id="PaymentManagement.Metadata" /></b>
                        </CardHeader>
                        <CardBody>
                            {selectedLink?.metadata && Object.keys(selectedLink?.metadata).length > 0 ?
                                <Row>
                                    <Col sm={4}>
                                        {Object.keys(selectedLink?.metadata).map((key, index) => (
                                            <Row key={index} className="mb-2">
                                                <Col>{key}</Col> 
                                                <Col>{selectedLink?.metadata[key]}</Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                                :
                                <div className='text-center'><FormattedMessage id="generic.table.nodata" /></div>
                            }
                        </CardBody>
                    </Card>

                    <Card className="border-0 mt-3">
                        <CardHeader className="mb-1 bg-light-dark py-1">
                            <Row className="align-items-center">
                                <Col sm={6}>
                                    <b><FormattedMessage id="PaymentManagement.Charges" /></b>
                                </Col>
                                <Col>
                                    <Form onSubmit={(e) => doSearch(e)} >
                                        <div className="d-flex align-items-center justify-content-end">
                                            <CustomDateRangePicker
                                                required
                                                startDate={startDate}
                                                startDateId="your_unique_start_date_id_customers"
                                                isOutsideRange={day => day > moment()}
                                                endDate={endDate}
                                                endDateId="your_unique_end_date_id_customers"
                                                onDatesChange={(startDate, endDate) => { setStartDate(startDate); setEndDate(endDate); }}
                                                numberOfMonths={1}
                                            />
                                            
                                            <Button className="btn btn-host btn-sm ml-2" type="submit">
                                                <i className="fa fa-search" />
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            {charges?.length > 0 ?
                                <>
                                    <CustomTable
                                        data={charges || []}
                                        columns={columns}
                                        search={false}
                                        small={true}
                                        exportCSV={false}
                                        hideSizePerPage={true}
                                        sizePerPage={limit}
                                        hasPagination={false}
                                    />
                                    {totalCount > 0 ?
                                        <div className="py-4 d-flex align-items-center">
                                            <div className='w-50' style={{maxWidth: '50%'}}>
                                                <ResultsPerPage
                                                    changeSizePerPage={changePageSize}
                                                    pageSize={limit}
                                                />
            
                                                {!global.isMobile ?
                                                    <span className="ml-2">
                                                        <TotalResults
                                                            end={page * limit + charges.length}
                                                            start={page * limit + 1}
                                                            total={totalCount}
                                                        />
                                                    </span>
                                                :''}
                                            </div>
                                            <div className="w-50 d-flex justify-content-end" style={{maxWidth: '50%'}}>
                                                <Pagination
                                                    isPrevDisabled={!endingBefore}
                                                    isNextDisabled={!startingAfter}
                                                    currentPage={page + 1}
                                                    handlePrevButton={() => handlePagination(-1)}
                                                    handleNextButton={() => handlePagination(1)}
                                                />
                                            </div>
                                        </div>
                                    : ''}
                                </>
                                :
                                <div className='text-center'><FormattedMessage id="generic.table.nodata" /></div>
                            }
                        </CardBody>
                    </Card>
                </BlockUi>
            </ModalBody>
        </Modal>
    )
};